import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CustomProductAttributeConfig } from '../../../types';
import { UntypedFormBuilder } from '@angular/forms';
import { AliveState } from '../../../../../core/ActiveState';
import { filter, tap } from 'rxjs/operators';
import { parseProductConfigEntry } from '../../helpers';
import cloneDeep from 'lodash/cloneDeep';
import { BehaviorSubject } from 'rxjs';
import { ConfigPickerFromPhotographerPreConfig } from '@ui/products/products-front/components/config-picker-from-photographer-pre-config/types';
import { translationProvider } from '@ui/nls/translations/translate.directive';

@Component({
    selector: 'lib-config-drawer',
    templateUrl: './config-drawer.component.html',
    styleUrls: ['./config-drawer.component.scss'],
    providers: [translationProvider('productFront')],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfigDrawerComponent extends AliveState implements OnInit {
  model = this.fb.group({});
  filtered: Array<CustomProductAttributeConfig & { fixing: boolean }> = [];
  @Output() _filtered = new EventEmitter<
    Array<CustomProductAttributeConfig & { fixing: boolean }>
  >();
  updateInProgress = false;
  @Output() updated = new EventEmitter<{
    [x: string]: string | boolean;
  }>();
  @Input() photographerPreConfig: ConfigPickerFromPhotographerPreConfig;
  @Input() preUpdated = new BehaviorSubject({});
  @Input() checkingInitialSettings = false;
  @Input() isFree = false;
  @Input() fixingAttributes = false;
  @Output() invalidFields = new EventEmitter<Array<string>>();
  @Input() resetOnNewConfig = false;
  _config: Array<CustomProductAttributeConfig> = [];
  @Input() hideImageRelatedCounters = false;

  get config() {
    return this._config;
  }

  @Input() set config(config: Array<CustomProductAttributeConfig>) {
    this._config = config;
    this.filter(true);
  }

  @Input() set preConfig(config: { [x: string]: any }) {
    config = cloneDeep(config);
    console.table(config);

    if (config) {
      Object.entries(config).forEach((value) => {
        if (typeof value[1]?.value === 'boolean') {
          config[value[0]] = config[value[0]].value;
        }
        if (typeof value[1]?.min === 'number') {
          config[value[0]] = config[value[0]].min;
        }
        if (typeof value[1]?.value === 'object') {
          config[value[0]] = config[value[0]].value[0];
        }
      });
      this.updateInProgress = true;
      if (this.resetOnNewConfig) {
        this.model.reset(config);
      } else {
        this.model.patchValue(config);
      }
      this.updateInProgress = false;

      console.log('%cAtrybuty', 'color: red');
      console.log('Atrybuty:', this.model.value);
      this.filter(true);
      this.updateInProgress = true;
      this.model.patchValue(config);
      this.updateInProgress = false;
    }
  }

  constructor(private fb: UntypedFormBuilder) {
    super();
  }

  filter(patch) {
    // if (!this.model.valid) {
    //   return;
    // }
    let filtered = [];
    const currentValue = { ...this.model.getRawValue() };
    if (this.config) {
      console.log(this.model.controls);
      this.updateInProgress = true;

      this.updated.emit(
        parseProductConfigEntry(
          [...this.config],
          this.model,
          currentValue,
          filtered,
          true,
          false,
          false
        )
      );
      this.updateInProgress = false;
    }
    filtered = filtered.filter(({ active }) => active);
    if (patch) {
      this.updateInProgress = true;
      this.model.patchValue(currentValue);
      this.updateInProgress = false;
    }
    const _filtered = [];
    filtered.forEach((filt) => {
      switch (filt.type) {
        case 'decoration':
        case 'list':
          _filtered.push({
            ...filt,
            fixing:
              !!this.model.value[
                Object.entries(this.model.value).find(
                  (value) => value[0] === filt.customId
                )[0]
              ]?.length,
          });
          break;
        case 'text':
          _filtered.push({
            ...filt,
            fixing: !!(
              filt.textConfig.min <=
                this.model.value[
                  Object.entries(this.model.value).find(
                    (value) => value[0] === filt.customId
                  )[0]
                ]?.length &&
              filt.textConfig.max >=
                this.model.value[
                  Object.entries(this.model.value).find(
                    (value) => value[0] === filt.customId
                  )[0]
                ]?.length
            ),
          });
          break;
        case 'counter':
          _filtered.push({
            ...filt,
            fixing:
              !!(
                filt.counterConfig.min <=
                  this.model.value[
                    Object.entries(this.model.value).find(
                      (value) => value[0] === filt.customId
                    )[0]
                  ] &&
                filt.counterConfig.max >=
                  this.model.value[
                    Object.entries(this.model.value).find(
                      (value) => value[0] === filt.customId
                    )[0]
                  ]
              ) || filt.counterConfig.takeCountFromImagesCount,
          });
          break;
        case 'size':
          _filtered.push({
            ...filt,
            fixing:
              !!this.model.value[
                Object.entries(this.model.value).find(
                  (value) => value[0] === filt.customId
                )[0]
              ].length,
          });
          break;
        case 'boolean':
          _filtered.push({
            ...filt,
            fixing: true,
          });
          break;
      }
    });
    if (JSON.stringify(this.filtered) !== JSON.stringify(_filtered)) {
      this.filtered = _filtered;
      this._filtered.emit(_filtered);

      this.model.patchValue(currentValue);

      console.log('UPDATE FILTERED');
    }
    this.updateInvalidFields();
  }

  trackOption(index, option: CustomProductAttributeConfig) {
    return option.customId;
  }

  updateInvalidFields() {
    const invalidFields = [];
    Object.entries(this.model.controls)
      .filter(([index, value]) => value.invalid)
      .forEach(([index, value]) => invalidFields.push(index));
    this.invalidFields.emit(invalidFields);
  }

  ngOnInit(): void {
    this.subscribeWhileAlive(
      this.model.valueChanges.pipe(
        filter(() => !this.updateInProgress),
        tap((currentValue) => {
          this.filter(false);
          this.updated.emit(this.model.value);
          this.updateInvalidFields();
        })
      ),
      this.preUpdated.pipe(
        tap((preUpdated) => {
          this.model.patchValue(preUpdated);
        })
      )
    );
    if (this.checkingInitialSettings) {
      this.updated.emit(this.model.value);
    }
    this.updateInvalidFields();
    this.updated.next(this.preUpdated.value);
    this.model.patchValue(this.preUpdated.value);
    this.model.updateValueAndValidity();
  }
}
